import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useLayoutContext } from 'modules/common/components/Layout/LayoutContext';
import { menuAreas } from 'modules/common/components/Layout/Sidebar/menuAreas';
import useThemeBreakpoint from 'modules/common/useThemeBreakpoint';

export default function useSubMenu(): [string | null, (item: string | null) => void] {
    const location = useLocation();
    const { isSidebarHidden } = useLayoutContext();
    const breakpoint = useThemeBreakpoint();
    const [subMenuSelected, setSubMenuSelected] = useState<string | null>(null);

    useEffect(() => {
        if (isSidebarHidden) {
            setSubMenuSelected(null);
            return;
        }

        const selectedItem = menuAreas.find((item) => {
            if (!item.basePath || !location.pathname.startsWith(item.basePath)) {
                return false;
            }

            if (
                item.submenu &&
                item.submenu.findIndex((submenu) => submenu.path && location.pathname.startsWith(submenu.path)) === -1
            ) {
                return false;
            }

            return true;
        });
        if (selectedItem?.basePath) {
            setSubMenuSelected(selectedItem.basePath);
        } else {
            setSubMenuSelected(null);
        }
    }, [isSidebarHidden, location.pathname, breakpoint]);

    return [subMenuSelected, setSubMenuSelected];
}
